import { config } from '@/config';

export const apiUrl = config.base.apiUrl;
const baseApiUrl = config.base.baseUrl.replace(/\/$/, '');
export const productGraphqlUrl = `${baseApiUrl}/graphql`;
